<template>
  <b-card
    class="mx-auto mt-3"
    style="width: 325px"
    no-body
  >
    <b-card-header>
      {{ $t('CategorySelectionModal.sentence1') }}
    </b-card-header>
    <b-card-body>
      <b-card-text>
        {{ $t('CategorySelectionModal.sentence2') }}
      </b-card-text>

      <b-input-group class="mt-3">
        <b-select
          v-model="selectedOption"
          :options="typeSelectionOptions"
        />

        <b-input-group-append>
          <b-button
            variant="primary"
            @click="handleConfirmSelection"
          >
            ok
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-card-body>
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      selectedOption: null,
    }
  },
  computed: {
    ...mapGetters('tenant', ['getCategoryOptions']),
    typeSelectionOptions() {
      return this.getCategoryOptions
    },
    defaultCategory() {
      return this.typeSelectionOptions[0].value
    },
  },
  created() {
    this.selectedOption = this.defaultCategory
  },
  methods: {
    handleConfirmSelection() {

      if (! this.selectedOption) {
        return
      }

      this.$emit('confirmSelection', {
        category: this.selectedOption,
      })
    },
  },
}
</script>
